module.exports = __webpack_public_path__ + "static/img/scene1.19578fa9.png";